import React, { useState, useEffect, useRef } from "react";
import "./ProfessionalEmail.css";
import { FaPaperPlane } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";

export default function EmailDesign() {

  const [users, setUsers] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [search, setSearch] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef();

  // Fetch users
  useEffect(() => {
    fetch("https://server.account.majestyfx.com/getClients.php")
      .then(res => {
        if (!res.ok) throw new Error("API Failed");
        return res.json();
      })
      .then(data => {
        if (data.success) {
          setUsers(data.clients);
        }
      })
      .catch(() => {
        toast.error("Failed to load users");
      });
  }, []);

  // Close dropdown outside click
  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const toggleUser = (id) => {
    setSelectedUsers(prev =>
      prev.includes(id)
        ? prev.filter(uid => uid !== id)
        : [...prev, id]
    );
  };

  const selectAll = () => {
    if (selectedUsers.length === users.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(users.map(u => u.id));
    }
  };

  const filteredUsers = users.filter(user =>
    user.account_name?.toLowerCase().includes(search.toLowerCase()) ||
    user.email?.toLowerCase().includes(search.toLowerCase())
  );

 const handleSendEmail = async () => {

  if (selectedUsers.length === 0) {
    toast.error("Please select at least one user");
    return;
  }

  if (!subject || !message) {
    toast.error("Subject and message required");
    return;
  }

  setSending(true);

  const formData = new FormData();
  formData.append("user_ids", JSON.stringify(selectedUsers));
  formData.append("subject", subject);
  formData.append("message", message);

  for (let i = 0; i < files.length; i++) {
    formData.append("attachments[]", files[i]);
  }

  try {
    const res = await fetch("https://server.account.majestyfx.com/admin_send_mail.php", {
      method: "POST",
      body: formData
    });

    const data = await res.json();

    if (data.success) {
      toast.success(data.message);
      setSubject("");
      setMessage("");
      setSelectedUsers([]);
      setFiles([]);
    } else {
      toast.error(data.error || "Failed");
    }

  } catch {
    toast.error("Server error");
  }

  setSending(false);
};

  return (
    <>
      <Toaster position="top-right" />

      <div className="email-container">

        <div className="header-section">
          <h1><FaPaperPlane /> Email Campaign Manager</h1>
          <p>Send professional emails to your clients with ease</p>
        </div>

        <div className="email-card">

          {/* Multi Select */}
          <div className="multi-select" ref={dropdownRef}>
            <div
              className="select-box"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {selectedUsers.length === 0
                ? "Select Recipients..."
                : `${selectedUsers.length} selected`}
            </div>

            {dropdownOpen && (
              <div className="dropdown-panel">
<input
  type="file"
  multiple
  onChange={(e) => setFiles(e.target.files)}
/>
                <input
                  type="text"
                  placeholder="Search user..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="search-input"
                />

                <button onClick={selectAll} className="select-all-btn">
                  {selectedUsers.length === users.length
                    ? "Unselect All"
                    : "Select All"}
                </button>

                <div className="dropdown-list">
                  {filteredUsers.map(user => (
                    <label key={user.id} className="dropdown-item">
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(user.id)}
                        onChange={() => toggleUser(user.id)}
                      />
                      {user.account_name}
                      <span className="email-small">{user.email}</span>
                    </label>
                  ))}
                </div>

              </div>
            )}
          </div>

          {/* Selected Tags */}
          {selectedUsers.length > 0 && (
            <div className="selected-tags">
              {users
                .filter(u => selectedUsers.includes(u.id))
                .slice(0, 5)
                .map(u => (
                  <span key={u.id} className="tag">
                    {u.account_name}
                  </span>
                ))}
              {selectedUsers.length > 5 && (
                <span className="tag-more">
                  +{selectedUsers.length - 5} more
                </span>
              )}
            </div>
          )}

          {/* Form */}
          <div className="form-section">

            <input
              type="text"
              placeholder="Email Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="input-field"
            />

            <textarea
              rows="6"
              placeholder="Write your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="textarea-field"
            />

            <button
              onClick={handleSendEmail}
              disabled={sending}
              className="send-btn"
            >
              {sending ? (
                <span className="loader"></span>
              ) : (
                `Send Email (${selectedUsers.length})`
              )}
            </button>

          </div>

        </div>
      </div>
    </>
  );
}
